var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-toolbar'),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"mt-5",attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('base.home'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }